import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./style.less";
import utils from "../../utils/utils";

class PipelineDateRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count_down: {
        d: "00",
        h: "00",
        m: "00",
        s: "00",
      },
      curRange: null,
      endTime: '',
      countDownTitle: ''
    };
    this.timer = null;
  }

  componentDidMount() {
    let endTime = '';

    const { list, countDownList } = this.props.config;
    list && list[0] && list[0].dateRangeList.slice(0, 4).forEach((range, rangeIndex) => {
      let startTimeStamp = null, endTimeStamp = null;
      let { startDate, endDate } = range
      startDate = startDate.replace('T', ' ')
      endDate = endDate.replace('T', ' ')

      startTimeStamp = new Date(startDate.replace(/-/g, '/')).getTime();
      endTimeStamp = new Date(endDate.replace(/-/g, '/')).getTime();

      if (startDate.indexOf('59') >= 0) {
        startTimeStamp = startTimeStamp + 59 * 1000;
      }

      if (endDate.indexOf('59') >= 0) {
        endTimeStamp = endTimeStamp + 59 * 1000;
      }
      
      const now = new Date().getTime()
      if (startDate && endDate && now >= startTimeStamp && now <= endTimeStamp) {
        range.active = true
      } else {
        range.active = false
      }
    });

    let countDownTitle = '';
    for (let index = 0; index < countDownList.length; index++) {
      const element = countDownList[index];
      let { title, startDate, endDate } = element;
      startDate = startDate.replace('T', ' ')
      endDate = endDate.replace('T', ' ')
      const now = new Date().getTime()
      if (startDate && endDate && now >= new Date(startDate.replace(/-/g, '/')).getTime() && now <= (new Date(endDate.replace(/-/g, '/')).getTime())) {
        endTime = endDate;
        countDownTitle = title;
        break;
      }
    }
    endTime && this.startCountDown(endTime);
    this.setState({ 
      curRange: list[0],
      endTime,
      countDownTitle
    })
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    this.timer = null;
  }

  renderCountDown = () => {
    const { d, h, m, s } = this.state.count_down;
    const { countDownTitle } = this.state;
    let prefix = "";
    if (d == '00' && h == '00' && m == '00' && s == '00') {
      return null
    } else {
      return `${countDownTitle}：${prefix}${d}天${h}小时${m}分${s}秒`
    }
  }

  render() {
    if (typeof window == 'undefined') {
      return null
    }
    let { curRange } = this.state;

    if (!curRange) {
      return null
    }

    const { baseConfig } = this.props.config;

    let bgRangeImg = ''
    let showHotRange = false

    const { d, h, m, s } = this.state.count_down;
    let rangeBgClass = 'range-bg';

    if (baseConfig.showCountDown && (d != '00' || h != '00' || m != '00' || s != '00')) {
      rangeBgClass += ' hasTime'
      bgRangeImg = curRange.rangeBgLarge
    } else {
      bgRangeImg = curRange.rangeBgSmall
    }

    if (utils.isIphoneX()) {
      rangeBgClass += ' iphoneX'
    }
    return (
      <Fragment>
        {
          curRange &&
          <div 
            ref={ref => this.rangeRef = ref}
            className={rangeBgClass}
            {...this.props['customAttributes']}
            style={{
              backgroundImage: `url(${bgRangeImg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain"
            }}
          >
            <div className="range-line">
              {
                curRange.dateRangeList.slice(0, 4).map((item, index) => {
                  return (
                    <div className={item.active ? (showHotRange ? "range-item active hot" : "range-item active") : "range-item"} key={index}>
                      {
                        !showHotRange &&
                        <React.Fragment>
                          <div className="range-date">{item.startDate.split("T")[0].substring(5).replace('-','.').replace('0', '')}-{item.endDate.split("T")[0].substring(5).replace('-','.').replace('0', '')}</div>
                          <div className="range-title">{item.title}</div>                      
                        </React.Fragment>
                      }
                    </div>
                  )
                })
              }
            </div>
            {
              baseConfig.showCountDown && (
                <p className={utils.isAndroid() ? "range-count-down android" : "range-count-down ios"}>
                  {this.renderCountDown()}
                </p>
              )
            }
          </div>
        }
      </Fragment>
    )
  }

  countDown(t) {
    var n = new Date().getTime(),
      c = t - n,
      d,
      h,
      m,
      s;
  
    // 结束执行
    if (c <= 0) {
      return {
        d: "00",
        h: "00",
        m: "00",
        s: "00",
      };
    }
  
    d = parseInt(c / 1000 / 60 / 60 / 24);
    h = parseInt(c / 1000 / 60 / 60 - 24 * d);
    m = parseInt(c / 1000 / 60 - 24 * 60 * d - 60 * h);
    s = parseInt(c / 1000 - 24 * 60 * 60 * d - 60 * 60 * h - 60 * m);
  
    // if (s < 10) {
    //   s = "0" + s;
    // }
    // if (m < 10) {
    //   m = "0" + m;
    // }
    // if (h < 10) {
    //   h = "0" + h;
    // }
    // if (d < 10) {
    //   d = "0" + d;
    // }
    return {
      d: d,
      h: h,
      m: m,
      s: s,
    };
  }

  startCountDown(end_time) {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    let timestramp = end_time.replace(/-/g, "/");
    let finish_time = new Date(timestramp).getTime();
    let count_down = this.countDown(finish_time);
    this.setState({
      count_down: count_down,
    });
    this.timer = setInterval(() => {
      // 计算倒计时
      finish_time = new Date(timestramp).getTime();
      count_down = this.countDown(finish_time);
      this.setState({
        count_down: count_down,
      });
    }, 1000);
  }
}

PipelineDateRange.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineDateRange };
export default PipelineDateRange;



// WEBPACK FOOTER //
// ./components/pipeline-date-range/index.js